

const Sidebar = () => import("@/components/layouts/Sidebar.vue");

const PopupIndex = () =>
    import("./components/Popups/PopupIndex.vue");
const PopupEdit = () =>
    import("./components/Popups/PopupEdit.vue");

export const popupRoutes =  {
        path: "/popups",
        component: Sidebar,
        meta: {
            middleware: "auth",
            title: "Popups",
            requiresAuth: true,
        },
        children: [
            {
                name: "popups.index",
                path: "/popups",
                component: PopupIndex,
                meta: {
                    middleware: "auth",
                    title: `Popups`,
                    requiresAuth: true,
                    permission: "popups.edit",
                },
            },
            {
                name: "popups.edit",
                path: "/popups/:id",
                component: PopupEdit,
                meta: {
                    middleware: "auth",
                    title: `Popup Edit`,
                    requiresAuth: true,
                    permission: "popups.edit",
                },
            },
        ],
    };
